var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03707 5H0.0370737V6V41.9794C-0.163865 45.683 0.47095 48.1555 1.48225 49.7384C2.50151 51.3338 3.89894 52 5.03745 52H32.5374C35.8512 52 38.5374 49.3137 38.5374 46V42V41H37.5374H34.0371V6V5H33.0371H1.03707ZM32.0371 41V7H2.03707V41.9706C2.03787 41.9986 2.03749 42.027 2.03591 42.0555C1.84274 45.5325 2.45712 47.5495 3.16764 48.6616C3.87338 49.7662 4.67596 50 5.03745 50C5.25681 50 5.93784 49.8278 6.56559 48.7103C7.19619 47.5876 7.73317 45.5507 7.53899 42.0555L7.48035 41H8.53745H32.0371ZM32.5374 50H8.12335C8.18698 49.9005 8.24902 49.7971 8.30931 49.6898C9.1084 48.2672 9.63119 46.1243 9.57517 43H36.5374V46C36.5374 48.2091 34.7466 50 32.5374 50Z",
    fill: "#81168C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 33,
    height: 36,
    fill: "#81168C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 42H37V47C37 49.2091 35.2091 51 33 51H5C2.79086 51 1 49.2091 1 47V42Z",
    fill: "#81168C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 46H37.5004C40.2618 46 42.5004 43.7614 42.5004 41V37H13.5004C13.9004 44.2 11.3337 46 10.0004 46ZM10.0004 46C8.50037 46 5.60037 44.2 6.00037 37",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0H5V1V37H7V2H37V14.4033L39 11.5337V1V0H38H6ZM39 21.9443L37 24.9443V37H39V21.9443Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96289 4.5H23.4629",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96289 8H32.9629",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96289 16H25.9629",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96289 24H21.9629",
    stroke: "white",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9629 32L26.9629 32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96289 12H28.9629",
    stroke: "white",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96289 20H29.9629",
    stroke: "white",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96289 29H25.9629",
    stroke: "white",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9629 24.5L28.5719 30.4118C28.3605 31.3103 29.3754 31.991 30.1265 31.4545L34.9629 28M29.9629 24.5L34.9629 28M29.9629 24.5L41.4629 8M34.9629 28L45.9629 11.5M41.4629 8L45.9629 11.5M41.4629 8C41.4629 8 43.723 3.67343 46.4629 5.5C49.4629 7.49998 45.9629 11.5 45.9629 11.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46L42 39.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 46.5L41.5 36.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 46.5L38.5 36.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 46.5L35.5 36.5",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon_1.01c6db7eeaa065ec19306c9760bb2934.svg";
export { ForwardRef as ReactComponent };